module.exports = __webpack_public_path__ + "img/icn-retraite.d95452ff.svg";